import type { SvgIconOwnProps } from '@mui/material/SvgIcon'
import { CircleSolidIcon, CloseIcon, StackIcons } from '@dhl-ui/icons'

type Props = Pick<SvgIconOwnProps, 'viewBox'> & Record<string, unknown>

export const ErrorIcon = ({ viewBox, ...props }: Props) => (
  <StackIcons {...props} variant="full" sx={{ mr: 1 }}>
    <CircleSolidIcon color="error" />
    <CloseIcon viewBox={viewBox} sx={{ color: 'common.white' }} />
  </StackIcons>
)
